export enum MASTERING_STEP {
  UPLOAD_TRACKS,
  GENERATE_PREVIEWS,
  COMPARE,
  CHOOSE_TRACKS,
}
